// Adapter pattern for carbon registry integration. Mock implementation for now.

export type Registry = {
  id: string;
  name: string;
  url: string;
};

export type OffsetCertificate = {
  id: string;
  registryId: string;
  amountKg: number;
  txId: string;
  createdAt: string;
};

export interface CarbonRegistryAdapter {
  listApprovedRegistries(): Promise<Registry[]>;
  createOffsetCertificate(registryId: string, amountKg: number): Promise<OffsetCertificate>;
  retireCredit(certificateId: string): Promise<{ success: boolean; txId: string }>;
}

class MockRegistry implements CarbonRegistryAdapter {
  private registries: Registry[] = [
    { id: 'mock-1', name: 'Mock Registry A', url: 'https://registry.example/a' },
    { id: 'mock-2', name: 'Mock Registry B', url: 'https://registry.example/b' }
  ];

  async listApprovedRegistries(): Promise<Registry[]> {
    return this.registries;
  }

  async createOffsetCertificate(registryId: string, amountKg: number): Promise<OffsetCertificate> {
    const id = `cert-${Math.random().toString(36).slice(2, 10)}`;
    const txId = `0x${Math.random().toString(16).slice(2).padEnd(64, '0').slice(0, 64)}`;
    return { id, registryId, amountKg, txId, createdAt: new Date().toISOString() };
  }

  async retireCredit(certificateId: string): Promise<{ success: boolean; txId: string }> {
    const txId = `0x${Math.random().toString(16).slice(2).padEnd(64, '0').slice(0, 64)}`;
    return { success: true, txId };
  }
}

export const carbonRegistry: CarbonRegistryAdapter = new MockRegistry();

// Routing helpers (mock): choose cheapest (assume registry-specific fee) or fastest
export async function chooseCheapestRoute(savedKg: number): Promise<{ registryId:string; feeEUR:number }> {
  const regs = await carbonRegistry.listApprovedRegistries();
  // mock fees per registry id
  const feeTable: Record<string,number> = { 'mock-1': 0.05, 'mock-2': 0.08 };
  const best = regs.map(r => ({ r, fee: (feeTable[r.id] ?? 0.07) * savedKg/1000 })).sort((a,b)=> a.fee-b.fee)[0];
  return { registryId: best.r.id, feeEUR: parseFloat(best.fee.toFixed(2)) };
}

export async function chooseFastestRoute(): Promise<{ registryId:string; etaDays:number }> {
  const regs = await carbonRegistry.listApprovedRegistries();
  // mock ETA: first is fastest
  return { registryId: regs[0].id, etaDays: 2 };
}


